import { render } from "./beautyClassify.vue?vue&type=template&id=67ba2cd8&scoped=true"
import script from "./beautyClassify.vue?vue&type=script&lang=js"
export * from "./beautyClassify.vue?vue&type=script&lang=js"

import "./beautyClassify.vue?vue&type=style&index=0&id=67ba2cd8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ba2cd8"]])

export default __exports__